import { render, staticRenderFns } from "./ApplyDetailPage.vue?vue&type=template&id=b8882f2c&scoped=true"
import script from "./ApplyDetailPage.vue?vue&type=script&lang=js"
export * from "./ApplyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ApplyDetailPage.vue?vue&type=style&index=0&id=b8882f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8882f2c",
  null
  
)

export default component.exports